<div class="protocol-monitoring">
  <div class="protocol-monitoring__header">
    <app-details-header
      [title]="headerTitle()"
      badgeText="観察記録" i18n-badgeText="@@details.protocolMonitoring.badgeText"
      badgeColor="#E65100"
      [patientName]="patientName()"
      [measureDate]="measureDate()"
      [measurer]="measurer()" />
  </div>

  <div class="protocol-monitoring__body">
    <!-- Observation Summary Chips -->
    <app-observation-chips
      [swallowCount]="swallowCount()"
      [coughCount]="coughCount()"
      [durationSec]="durationSec()" />

    <!-- Monitoring Pictures (Before / After Meal) -->
    @if (hasPictures()) {
      <div class="pictures-card">
        <div class="pictures-card__header">
          <mat-icon class="pictures-card__icon">local_dining</mat-icon>
          <span class="pictures-card__title" i18n="@@details.protocolMonitoring.picturesTitle">食前・食後画像</span>
        </div>
        <div class="pictures-card__body">
          <div class="pictures-card__grid">
            <!-- Before meal -->
            <div class="picture-slot">
              <span class="picture-slot__label" i18n="@@details.protocolMonitoring.beforeMealLabel">食事前</span>
              @if (beforeMealImage() && !beforeImageFailed()) {
                <img
                  [src]="beforeMealImage()"
                  alt="食事前の画像" i18n-alt="@@details.protocolMonitoring.beforeMealImageAlt"
                  class="picture-slot__image"
                  (error)="onImageError('before')" />
              } @else {
                <div class="picture-slot__empty">
                  <mat-icon class="picture-slot__empty-icon">image_not_supported</mat-icon>
                  @if (beforeMealImage()) {
                    <span class="picture-slot__empty-text" i18n="@@details.protocolMonitoring.imageLoadError">画像の読み込みに失敗しました</span>
                  } @else {
                    <span class="picture-slot__empty-text" i18n="@@details.protocolMonitoring.imageNone">画像なし</span>
                  }
                </div>
              }
            </div>

            <!-- After meal -->
            <div class="picture-slot">
              <span class="picture-slot__label" i18n="@@details.protocolMonitoring.afterMealLabel">食事後</span>
              @if (afterMealImage() && !afterImageFailed()) {
                <img
                  [src]="afterMealImage()"
                  alt="食事後の画像" i18n-alt="@@details.protocolMonitoring.afterMealImageAlt"
                  class="picture-slot__image"
                  (error)="onImageError('after')" />
              } @else {
                <div class="picture-slot__empty">
                  <mat-icon class="picture-slot__empty-icon">image_not_supported</mat-icon>
                  @if (afterMealImage()) {
                    <span class="picture-slot__empty-text" i18n="@@details.protocolMonitoring.imageLoadError">画像の読み込みに失敗しました</span>
                  } @else {
                    <span class="picture-slot__empty-text" i18n="@@details.protocolMonitoring.imageNone">画像なし</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Wave + Posture + Event Timeline Card -->
    @if (showWaveCard()) {
      <div class="timeline-card">
        <div class="timeline-card__header">
          <div class="timeline-card__header-left">
            <mat-icon class="timeline-card__icon">sync</mat-icon>
            <span class="timeline-card__title">
              <span class="timeline-card__title-main" i18n="@@details.protocolMonitoring.syncViewTitle">同期ビュー</span>
              <span class="timeline-card__title-detail" i18n="@@details.protocolMonitoring.syncViewDetail"> — 波形・姿勢・イベント</span>
            </span>
          </div>
          <span class="timeline-card__duration">
            <span i18n="@@details.protocolMonitoring.recordingDuration">録音時間:</span> {{ recordData()?.data?.totalTime ?? '' }}
          </span>
        </div>

        <div class="timeline-card__grid">
          <!-- Waveform -->
          <div class="timeline-card__wave">
            <app-measured-data-wave-card
              [frameless]="true"
              [showMiniPlayback]="true"
              [recordData]="recordData()"
              [recordtype]="recordtype()"
              [recordLoadingSuccess]="recordLoadingSuccess()"
              [waveLoadingPercent]="waveLoadingPercent()"
              [waveErrorMessage]="waveErrorMessage()"
              [selectedEvent]="selectedEvent()"
              [currentStartOffset]="currentStartOffset()"
              [playing]="playing()"
              [timelineOffsetReference]="timelineOffsetReference()"
              [zoomValue]="zoomValue()"
              (offsetToggle)="offsetToggle.emit($event)"
              (seek)="seek.emit($event)"
              (playPauseClicked)="playPauseClicked.emit()"
              (zoomMinusClicked)="zoomMinusClicked.emit()"
              (zoomResetClicked)="zoomResetClicked.emit()"
              (zoomPlusClicked)="zoomPlusClicked.emit()" />
          </div>

          <!-- Posture (Neck Angle) -->
          <div class="timeline-card__posture">
            <app-measured-data-neck-angle-card
              [frameless]="true"
              [chartOption]="chartOption()"
              [currentChartOption]="currentChartOption()"
              [currentOrientation]="currentOrientation()"
              (chartInit)="chartInit.emit($event)"
              (currentChartInit)="currentChartInit.emit($event)" />
          </div>

          <!-- Event Table -->
          <div class="timeline-card__events">
            <app-event-table
              [events]="events()"
              (seekToEvent)="onEventSeek($event)" />
          </div>

          <!-- Data Footer -->
          <div class="timeline-card__footer">
            <app-data-footer
              [dataId]="dataId()"
              nbModel="nbModel v2.1"
              [downloadUrl]="downloadUrl()" />
          </div>
        </div>
      </div>
    }

    <!-- Disclaimer -->
    <app-disclaimer [message]="disclaimer" />
  </div>
</div>
